import { RestrictedCdnSignature } from "@iventis/api-helpers";
import { rootStore } from "./state/root.store";
import { updateTerrainSignatures } from "./state/map.slice.thunks";

// Checks if terrain signatures need refreshing and updates them if they do
export const refreshTerrainSignatures = (signatures: RestrictedCdnSignature[]): void => {
    if (areTerrainSignaturesExpired(signatures)) {
        const { mapReducer } = rootStore.getState();
        rootStore.dispatch(updateTerrainSignatures(mapReducer.mapModule.terrain3D.value.customTerrains));
    }
};

const areTerrainSignaturesExpired = (signatures: RestrictedCdnSignature[]): boolean => {
    let expired = false;
    signatures.forEach((signature) => {
        const expiry = new Date(signature.expiry);
        const now = new Date();
        const msRemainingUntilExpiry = expiry.getTime() - now.getTime();
        if (msRemainingUntilExpiry < 10000) {
            expired = true;
        }
    });
    return expired;
};
